import { mediaObserver, type MediaQueries } from "svelte-media-observer"
import resolveConfig from "tailwindcss/resolveConfig"
import tailwindConfig from "../../tailwind.config" // Fix the path

type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl"
const fullConfig = resolveConfig(tailwindConfig)

if (!fullConfig.theme) {
  throw new TypeError("Tailwind config is missing theme")
}

const screens = fullConfig.theme.screens as Record<Breakpoint, string>

const mediaQueries: MediaQueries<Breakpoint> = Object.entries(screens).map(
  ([key, value]) => [key as Breakpoint, `(min-width: ${value})`]
)

const media = mediaObserver(mediaQueries)

export default media

export const getBreakpointValue = (value: Breakpoint): number =>
  +screens[value].slice(0, screens[value].indexOf("px"))

export const matchesBreakpoint = (breakpoint: Breakpoint) =>
  window.matchMedia(`(min-width: ${screens[breakpoint]}`).matches
